import React from 'react';
import ReactDOM from 'react-dom';
import PermissionCapabilities from './permission-capabilities';
import NotificationPreferences from './notification-preferences';
import LogAccessSummary from './log-access-summary';
import MemberGroupList from './member-group-list';
import APIToken from './api-token';
import { glyph, accessLevel, groupAccessLevel, purgeLogsAccess } from 'members/helpers';

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: PT.customerGroups,
      currentMemberId: PT.currentMember.member.id,
      readOnly: PT.currentMember.member.read_only,
      canAccessAllGroups: PT.currentMember.member.can_access_all_groups,
      manageMembers: PT.currentMember.member.manage_members,
      manageBilling: PT.currentMember.member.manage_billing,
      hasLogAccess: PT.currentMember.member.has_log_access,
      purgeLogs: PT.currentMember.member.purge_logs,
      receiveBillingEmails: PT.currentMember.member.receive_billing_emails,
      receiveUsageEmails: PT.currentMember.member.receive_usage_emails,
      editableNotifications: PT.currentMember.member.editable_notifications,
      groupIds: PT.currentMember.member.group_ids,
      apiTokenId: PT.currentMember.member.api_token.id,
      apiToken: PT.currentMember.member.api_token.value,
      apiTokenLastRequestAt: PT.currentMember.member.api_token.last_request_at,
      apiTokenLastRequestIp: PT.currentMember.member.api_token.last_request_ip,
      sso: PT.currentMember.customer.sso,
      paysSomeoneElse: PT.currentMember.customer.pays_someone_else
    }
  }

  render() {
    return (
      <div className="edit-mode">
        <div className="list-box sectioned permissions-box mod-editable">
          <div className="grid flex">
            <PermissionCapabilities
              isEditable={false}
              isVisible={true}
              manageMembers={this.state.manageMembers}
              manageBilling={this.state.manageBilling}
              hasLogAccess={this.state.hasLogAccess}
              onCheckboxChange={() => {}}
              onLogAccessChange={() => {}}
            />

            <NotificationPreferences
              isEditable={true}
              memberId={this.state.currentMemberId}
              receiveUsageEmails={this.state.receiveUsageEmails}
              receiveBillingEmails={this.state.receiveBillingEmails}
              editableNotifications={this.state.editableNotifications}
              paysSomeoneElse={this.state.paysSomeoneElse}
              onCheckboxChange={() => {}}
              noNotificationCss={() => {}}
              glyph={() => {}}
            />
          </div>

          <LogAccessSummary
            isEditable={false}
            isVisible={this.state.hasLogAccess && !this.state.sso}
            manageMembers={this.state.manageMembers}
            readOnly={this.state.readOnly}
            canAccessAllGroups={this.state.canAccessAllGroups}
            purgeLogs={this.state.purgeLogs}
            accessLevel={accessLevel}
            groupAccessLevel={groupAccessLevel}
            purgeLogsAccess={purgeLogsAccess}
          />

          <MemberGroupList
            isEditable={false}
            isVisible={this.state.hasLogAccess && !this.state.sso}
            canAccessAllGroups={this.state.manageMembers || this.state.canAccessAllGroups}
            groups={this.state.groups}
            groupIds={this.state.groupIds}
            onGroupCheckboxChange={() => {}}
            glyph={glyph}
          />

          <APIToken
            memberId={this.state.currentMemberId}
            apiTokenId={this.state.apiTokenId}
            apiToken={this.state.apiToken}
            apiTokenLastRequestAt={this.state.apiTokenLastRequestAt}
            apiTokenLastRequestIp={this.state.apiTokenLastRequestIp}
            apiTokenVisible={true}
          />
        </div>
      </div>
    );
  }
};

$(function() {
  ReactDOM.render(<Profile />, document.getElementById('member-profile-ui'));
});
